const methodNamesMap = new Map();

export function remapMethod(name, alias) {
  methodNamesMap.set(alias, name);
}

export function remapMethods(mappings) {
  for (const [name, alias] of mappings) {
    remapMethod(name, alias);
  }
}

export function resolveMethodName(nameOrAlias) {
  return methodNamesMap.get(nameOrAlias) || nameOrAlias;
}
